














import Person from './person.vue'
import Device from './device.vue'
import AbpBase from "@/lib/abpbase"
import {Component} from "vue-property-decorator"

@Component({
	components:{Person, Device}
})
export default class PatientStatistics extends AbpBase{


}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/roomInfo/index.vue